import { baseUrl } from "../shared/api";

export function userTradeDocument(userID, tradeDocumentType, id) {
  return `${baseUrl()}/api/v2/users/${userID}/${tradeDocumentType}/${id}`;
}

export const tradeDocumentsURL = (withDraft=false, page) => {
  if (withDraft) {
    return `${baseUrl()}/api/v2/trade_documents?with_draft_from=2019-02-19&page=${page}`;
  } else {
    return `${baseUrl()}/api/v2/trade_documents?page=${page}`;
  }
};



// WEBPACK FOOTER //
// ./src/features/trade_documents/apiUrls.js